import "dropzone";
import "cleave.js";
import "jasny-bootstrap/js/fileinput";
import "select2/dist/js/select2.full.js";
import "select2/dist/js/i18n/es";
import "select2/dist/js/i18n/it";
import "jquery-ui/ui/widgets/datepicker";
import moment from "moment";
import autosize from "autosize";
import jqueryDatepickerES from "jquery-datepicker/i18n/jquery.ui.datepicker-es";
import jqueryDatepickerET from "jquery-datepicker/i18n/jquery.ui.datepicker-et";
import jqueryDatepickerIT from "jquery-datepicker/i18n/jquery.ui.datepicker-it";
import jqueryDatepickerFR from "jquery-datepicker/i18n/jquery.ui.datepicker-fr";

import Translations from "../plugins/translations"

window.moment = moment;
window.autosize = autosize;

let Form = {
    init: () => {
        Form.initFormValidation();
        Form.initFormControls();
        Form.initDropzone();
        Form.initSelect2();
        Form.initDatepicker();
        Form.initFileinput();
        Form.initTextarea();
    },

    initFormValidation: () => {
        let $forms = $('.needs-validation');

        if (!$forms.length) return;

        $forms.each(function () {
            let $this = $(this),
                $requiredDatepickers = $this.find('.datepicker[required]'),
                $requiredFields = $this.find('input[required], select[required], textarea[required]'),
                $submit = $this.find('[type="submit"]');

            $requiredDatepickers.on('change', () => checkRequiredFieldsFilled($requiredFields, $submit));
            $requiredFields.on('input', Utility.debounce(() => checkRequiredFieldsFilled($requiredFields, $submit)));
            $this.find('input, select, textarea').on('input', Utility.debounce(handleCheckValidity));

            checkRequiredFieldsFilled($requiredFields, $submit);

            $this.on('submit', (event) => {
                if ($(this)[0].checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                let $invalidInputs = $(this).find('.is-invalid');

                $(this)[0].classList.add('was-validated');
                if ($invalidInputs.length) $invalidInputs[0].scrollIntoView({behavior: "smooth", block: "center"});
            });
        });

        function handleCheckValidity() {
            $(this).removeClass('is-valid is-invalid').addClass(this.checkValidity() || 'is-invalid');
        }

        function checkRequiredFieldsFilled(requiredFields, submit) {
            let hasEmptyFields = false,
                hasInvalidFields = false;

            requiredFields.each(function () {
                if (!$(this).val()) hasEmptyFields = true;
                if (!$(this)[0].checkValidity()) hasInvalidFields = true;
            });

            (hasEmptyFields || hasInvalidFields) ? submit.attr('disabled', true) : submit.removeAttr('disabled');
        }
    },

    initFormControls: () => {
        let $inputsList = $('.form-control');

        if (!$inputsList.length) return;

        $inputsList.each(function () {
            const $inputSelector = $(this),
                  isAlphaNum = $inputSelector.data('alphanum');

            if (isAlphaNum) $inputSelector.on('input', handleAlphaNumericInputEvent);

            function handleAlphaNumericInputEvent() {
                const $this = $(this),
                    regex = /[^a-z0-9]/gi,
                    value = $this.val();

                let count = this.selectionStart;

                if (regex.test(value)) {
                    $this.val(value.replace(regex, ''));
                    count--;
                }

                this.setSelectionRange(count, count);
            }
        })
    },

    initDropzone: ($object, opt) => {
        let $dropzone = $object ? $($object) : $('form#dropzone');

        if (!$dropzone.length) return;

        let hasErrors = false,
            previewTemplate = `
                  <div class="dropzone-previews-template">
                    <div>
                      <div class="progress progress-striped active" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
                        <div class="progress-bar progress-bar-success" style="width:0%;" data-dz-uploadprogress></div>
                      </div>
                    </div>
                    <div>
                      <strong class="type text-primary"></strong>
                    </div>
                    <div>
                      <strong class="name" data-dz-name></strong>
                      <strong class="error text-danger" data-dz-errormessage></strong>
                    </div>
                    <div>
                      <div class="size" data-dz-size></div>
                    </div>
                    <div class="ml-auto">
                      <i class="icon-close" data-dz-remove></i>
                    </div>
                  </div>`;

        let options = {
            previewTemplate: previewTemplate,
            acceptedFiles: '.pdf, .jpg, .jpeg, .png, .zip',
            maxFilesize: '20',
            dictFileTooBig: "File size ({{filesize}} MB) exceeds allowed limit {{maxFilesize}} MB.",
            parallelUploads: 1,
            createImageThumbnails: false,
            autoProcessQueue: true,
            init: function () {
                this.on('uploadprogress', function (file, progress) {
                    let progressElement = file.previewElement.querySelector("[data-dz-uploadprogress]");
                    progressElement.style.width = progress + "%";
                });
                this.on('error', function (file, errorMsg) {
                    showErrorMessage(errorMsg);
                    hasErrors = true;
                    this.removeFile(file);
                });
                this.on('success', function (file, data) {
                    if (data.status === 'danger') {
                        showErrorMessage(data.message);
                        this.removeFile(file);
                        hasErrors = true;
                    }
                });
                this.on("queuecomplete", function () {
                    if (!hasErrors) {
                        location.reload();
                    }
                    hasErrors = false;
                });

                function showErrorMessage(errorMsg) {
                    $('#uploadErrors').append('<div class="system-alert system-alert-danger upload-error">');
                    $('.upload-error').append(errorMsg)
                        .append('<i class="icon-close-small remove-alert remove-upload-error"></i>');

                    $('.remove-upload-error').click(function () {
                        $('.upload-error').fadeOut('normal', function () {
                            $('.upload-error').remove();
                        });
                    });
                }
            },
            accept: function (file, done) {
                // Add filetype to the previewTemplate
                file.previewElement.querySelector(".type").innerHTML = '.' + file.name.split('.').pop();
                done();
            }
        };

        $.extend(true, options, opt);

        $dropzone.dropzone(options);
    },

    initSelect2: ($object, opt) => {
        let $select2 = $object ? $($object) : $('.select-element:not(.select2-hidden-accessible)');

        if (!$select2.length) return;

        $select2.each(function() {
            let $this = $(this),
                additionalClass = $this.data('additional-class'),
                additionalClassDropdown = $this.data('additional-class-dropdown'),
                hideSearch = $this.data('hide-search'),
                placeholder = $this.data('placeholder'),
                dropdownParent = $this.parents('.modal-body').length ? $this.parents('.modal-body') : $(document.body),
                options = {
                    searchInputPlaceholder: 'Search...',
                    dropdownParent: dropdownParent,
                    placeholder: placeholder
                };

            if (hideSearch) $.extend(options, { minimumResultsForSearch: -1 })

            if (additionalClass || additionalClassDropdown) {
                $.extend(options, {
                    containerCssClass: additionalClass,
                    dropdownCssClass: additionalClassDropdown
                });
            }

            $.extend(options, opt);

            $this.select2(options);
        });
    },

    initDatepicker: ($object, opt) => {
        let $datepicker = $object ? $($object) : $('.datepicker');

        if (!$datepicker.length) {
            return;
        }
        
        if (Session.locale === 'es') jqueryDatepickerES($);
        if (Session.locale === 'et') jqueryDatepickerET($);
        if (Session.locale === 'it') jqueryDatepickerIT($);
        if (Session.locale === 'fr') jqueryDatepickerFR($);

        $datepicker.each(function () {
            const $this = $(this);

            let options = {
                dateFormat: "yy-mm-dd",
                showOtherMonths: true,
                selectOtherMonths: true,
                firstDay: 1,
                minDate: $this.data('min-date') || null,
                maxDate: $this.data('max-date') || null,
                onSelect: function (dateText, instance) {
                    $(this).trigger('focusout');
                    if (dateText !== instance.lastVal) $(this).change();
                }
            };

            $.extend(options, opt);

            $this.datepicker(options).attr('readonly', Utility.isTouchDevice());

            new Cleave($this, {
                date: true,
                delimiter: '-',
                datePattern: ['Y', 'm', 'd']
            })
        });
    },

    initFileinput: () => {
        let $fileinput = $('.file-input');

        if (!$fileinput.length) return;

        $fileinput.each(() => $(this).fileinput());
    },

    initTextarea: () =>  {
        let $textarea = $('textarea');

        if (!$textarea.length) return;

        autosize($textarea.toArray().filter(area => !area.classList.contains("no-autosize")));
    }
};

export default Form;

